import React from 'react';
     import '/vercel/path0/docs/theme/global-component.md?watch=parent';
export const demos = {
  'docs-theme-global-component-demo-0': {
    component: React.memo(React.lazy(async function() {
  const { default: React } = await import('react');
return {
    default: ()=>/*#__PURE__*/ React.createElement("h1", null, "当前 barValue 属性值为：Big Bar!")
};

})),
    asset: null,
    context: undefined,
    renderOpts: undefined,
  },
};